export default "__VITE_PUBLIC_ASSET__df047a15__"